import { createFileRoute } from '@tanstack/react-router';
import { ChannelInbox } from '../../components/inbox/ChannelInbox';
import { useMessengerInbox } from '../../components/inbox/adapters/useMessengerInbox';
import { messengerCapabilities } from '../../components/inbox/capabilities/messenger';

/**
 * Messenger inbox — now a thin wrapper over the shared `ChannelInbox` shell.
 * The Messenger adapter owns all `facebook.inbox.*` calls + addressing +
 * realtime; the capability descriptor turns on only what Messenger supports.
 * Routing through the shared MessageBubble fixes the old dark-mode bubble bug,
 * and the adapter's name fallback (profileName → contact name → psid) + the
 * header refresh button surface the counterparty name.
 */
function MessengerInbox() {
  const { contactId } = Route.useSearch();
  return (
    <ChannelInbox
      adapter={useMessengerInbox()}
      capabilities={messengerCapabilities}
      initialContactId={contactId ?? null}
    />
  );
}

export const Route = createFileRoute('/vendor/facebook/inbox')({
  component: MessengerInbox,
  validateSearch: (s: Record<string, unknown>): { contactId?: number } => {
    const n = typeof s.contactId === 'number' ? s.contactId : Number(s.contactId);
    return Number.isFinite(n) && n > 0 ? { contactId: n } : {};
  },
});
